<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h1>Franchise Reports</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="well">
          <form class="form-inline" @submit.prevent="applyFilters">
            <div class="form-group" style="margin-right: 10px;">
              <label for="fr-start-date">Start Date</label>
              <input type="date" id="fr-start-date" class="form-control" v-model="localFilters.start_date" :max="localFilters.end_date" required />
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="fr-end-date">End Date</label>
              <input type="date" id="fr-end-date" class="form-control" v-model="localFilters.end_date" :min="localFilters.start_date" required />
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="fr-schools">Location</label>
              <select id="fr-schools" class="form-control" v-model="selectedSchoolId">
                <option :value="null">All locations</option>
                <option v-for="school in schools" :key="school.id" :value="school.id">{{ school.name }}</option>
              </select>
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="fr-granularity">Granularity</label>
              <select id="fr-granularity" class="form-control" v-model="localFilters.granularity">
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
            <div class="form-group" style="margin-right: 10px;">
              <label for="fr-comparison">Compare To</label>
              <select id="fr-comparison" class="form-control" v-model="localFilters.yoy_type">
                <option value="same_period">Same period last year</option>
                <option value="rolling">Previous period</option>
              </select>
            </div>
            <button type="submit" class="btn btn-dc" data-testid="franchise-reports-apply">Apply</button>
          </form>
        </div>
      </div>
    </div>

    <div v-if="error" class="row">
      <div class="col-xs-12">
        <div class="alert alert-danger">{{ error }}</div>
      </div>
    </div>

    <div v-if="loading" class="row">
      <div class="col-xs-12 text-center">
        <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
      </div>
    </div>

    <div v-if="reportData && !loading">
      <p class="text-muted">
        {{ reportData.summary.period.start_date }} to {{ reportData.summary.period.end_date }},
        compared with {{ reportData.yoy_comparison.previous_period.start_date }} to {{ reportData.yoy_comparison.previous_period.end_date }}
      </p>

      <EcommerceYoYComparison
        :summary="reportData.summary"
        :yoy-comparison="reportData.yoy_comparison"
      />

      <div class="row">
        <div class="col-xs-12">
          <RevenueTimeSeriesChart :time-series="reportData.time_series" />
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <RevenueBySchoolChart :by-school="reportData.by_school" />
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <SchoolBreakdownTable :by-school="reportData.by_school" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EcommerceYoYComparison from '../ecommerce-dashboard/components/EcommerceYoYComparison.vue';
import RevenueTimeSeriesChart from '../ecommerce-dashboard/components/RevenueTimeSeriesChart.vue';
import RevenueBySchoolChart from './components/RevenueBySchoolChart.vue';
import SchoolBreakdownTable from './components/SchoolBreakdownTable.vue';

function copyFilters(filters) {
  return Object.assign({}, filters, { school_ids: filters.school_ids.slice() });
}

export default {
  name: 'FranchiseReports',
  components: {
    EcommerceYoYComparison,
    RevenueTimeSeriesChart,
    RevenueBySchoolChart,
    SchoolBreakdownTable
  },
  props: {
    reportData: { type: Object, default: null },
    schools: { type: Array, default: function() { return []; } },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
    filters: { type: Object, required: true },
    onFilterChange: { type: Function, required: true }
  },
  data: function() {
    return {
      localFilters: copyFilters(this.filters)
    };
  },
  computed: {
    // The report API filters by a list of schools; the dropdown picks one location or all of them.
    selectedSchoolId: {
      get: function() {
        return this.localFilters.school_ids.length ? this.localFilters.school_ids[0] : null;
      },
      set: function(schoolId) {
        this.localFilters.school_ids = schoolId === null ? [] : [schoolId];
      }
    }
  },
  watch: {
    filters: {
      handler: function(newVal) {
        this.localFilters = copyFilters(newVal);
      },
      deep: true
    }
  },
  methods: {
    applyFilters: function() {
      this.onFilterChange(copyFilters(this.localFilters));
    }
  }
};
</script>
